<template>
    <div>
        <v-dialog v-model="dialoganswerModal" max-width="800px" scrollable overlay-opacity="0.8" overlay-color="#000">
            <v-card class="mk-note-modal hf-dialog">
                <v-card-title>
                    <div
                        class="w-100 d-flex justify-content-between align-items-center"
                    >
                        <h2 class="mb-0">Manage Comments</h2>

                        <button
                            @click="$parent.dialoganswer = false"
                            class="btn btn-close-modal"
                            text
                        >
                            <i class="fas fa-times"></i>
                        </button>
                    </div>
                </v-card-title>

                <v-card-text class="py-0">
                    <v-container class="px-0">
                        <div class="row mb-4">
                            <div class="col-12 pt-0">
                                <div style="margin-top: 32px;" class="d-flex align-items-center">
                                    <div class="mr-4">
                                        <img
                                            v-if="artwork.image_url"
                                            :src="artwork.image_url"
                                            width="100"
                                            height="100"
                                            style="border-radius: 8px;"
                                        />
                                    </div>
                                    <div>
                                        <h3>{{ artwork.name }}</h3>
                                        <p class="mb-0">Question: {{ artwork.question }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="d-flex justify-content-between align-items-center">
                            <h3 class="mb-0">Comments</h3>

                            <div class="[ search-input-wrap ]" style="width: 185px;">
                                <v-text-field
                                    v-model="search"
                                    prepend-inner-icon="mdi-magnify"
                                    placeholder="Search"
                                    single-line
                                    hide-details
                                ></v-text-field>
                            </div>
                        </div>

                        <v-data-table
                            :page="page"
                            :pageCount="numberOfPages"
                            :headers="headers"
                            :items="items"
                            :options.sync="options"
                            :server-items-length="totalItems"
                            :loading="loading"
                            class="elevation-1"
                            hide-default-footer
                        >
                            <template v-for="header in headers.filter((header) => header.hasOwnProperty('formatter'))" v-slot:[`item.${header.value}`]="{ header, item }">
                                {{ formatValue(header, item) }}
                            </template>

                            <template v-slot:item.switch="{ item, header }">
                                <div class="mt-4 d-flex align-items-center">
                                    <v-switch
                                        v-model="item.is_published"
                                        @change="changePublish(item)"
                                        inset
                                        color="var(--color-green)"
                                    ></v-switch>
                                </div>
                            </template>
                            <template v-slot:item.actions="{ item, header }">
                                <v-icon
                                    dense
                                    @click="deleteItem(item)"
                                >
                                    mdi-trash-can-outline color-primary
                                </v-icon>
                            </template>
                        </v-data-table>

                        <div class="[ pgt-page-number-wrap ] mt-2">
                            <v-pagination
                                v-model="page"
                                :length="numberOfPages"
                            ></v-pagination>
                        </div>
                    </v-container>
                </v-card-text>


                <!-- <v-card-actions>
                    <v-container>
                        <v-row>
                            <v-col cols="12">
                                <div
                                    class="d-flex justify-content-between align-items-center"
                                >
                                    <button
                                        @click="$parent.dialoganswer = false"
                                        class="btn btn-default"
                                        text
                                    >
                                        Close
                                    </button>
                                </div>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-actions> -->

            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import ArtworkAnswer from "../../models/ArtworkAnswer";

export default {
    props: {
        artwork: {
            type: Object,
        },
        dialoganswer: {
            type: Boolean,
        },
        artwork_statuses: {
            type: Array,
        },
    },
    data() {
        return {
            headers: [
                { text: "ID", value: "id" },
                {
                    text: "Comment",
                    value: "comment"
                },
                {
                    text: "Created At",
                    value: "created_at",
                    formatter: "date",
                    format: "DD/MM/YYYY HH:MMA",
                },
                { text: "Publish", value: "switch" },
                { text: "Actions", value: "actions", sortable: false },
            ],
            page: 1,
            totalItems: 0,
            numberOfPages: 0,
            options: {},
            items: [],
            loading: true,
            search: '',
            awaitingSearch: false,
            dialoganswerModal: false
        };
    },
    watch: {
        options: {
            handler() {
                this.readDataFromAPI();
            },
        },
        search: function (val) {
            if (!this.awaitingSearch) {
                setTimeout(() => {
                    this.readDataFromAPI();
                    this.awaitingSearch = false;
                }, 1000); // 1 sec delay
            }
            this.awaitingSearch = true;
        },
        deep: true,
    },
    mounted() {
        this.dialoganswerModal = this.dialoganswer;
    },
    methods: {
        async readDataFromAPI() {
            const { page, itemsPerPage } = this.options;

            this.page = page;
            this.itemsPerPage = itemsPerPage;

            this.options.sortByText = '';
            this.options.sortByDesc = '';

            if(this.options.sortBy.length === 1) {
                this.options.sortByText = this.options.sortBy[0];
                this.options.sortByDesc = this.options.sortDesc[0];
            }

            try {
                this.items = [];
                this.loading = true;

                let modelDetails = await ArtworkAnswer
                                    .include('status')
                                    .where('artwork_id', this.artwork.id);

                modelDetails.page(this.page).limit(this.itemsPerPage);

                if (this.options.sortByText != "") {
                    modelDetails.orderBy((this.options.sortByDesc ? "-" : "") + this.options.sortByText);
                } else {
                    modelDetails.orderBy("-created_at");
                }

                if (this.search != "") {
                    modelDetails.where("search", this.search);
                }

                let modelData = await modelDetails.get();

                if (modelData.data !== undefined) {
                    this.items = modelData.data;
                    this.page = modelData.current_page;
                    this.numberOfPages = modelData.last_page;
                    this.itemsPerPage = modelData.per_page;
                    this.totalItems = modelData.total;
                }

                this.loading = false;
            } catch(err) {
                Vue.swal('', err.message, 'error');
            }
        },

        formatValue(header, item) {
            if(header.formatter == 'date') {
                return moment(item[header.value]).format(header.format);
            } else if(header.formatter == 'count') {
                return item[header.value].length;
            } else if(header.formatter == 'options') {
                let name = '';
                header.options.forEach((value, index) => {
                    if(value.id == item[header.value]) {
                        name = value.name;
                    }
                });

                return name;
            }
        },

        changePublish(item) {
            item.save().then((response) => {
                if(!response.data) {
                    this.readDataFromAPI();
                }
            });
        },

        deleteItem(item) {
            this.$swal({
                title: "Are you sure you want to delete this?",
                customClass: {
                confirmButton: "order-2 btn btn-primary ml-1",
                cancelButton: "order-1 btn btn-grey mr-1",
                },
                buttonsStyling: false,
                showCancelButton: true,
                confirmButtonText: "Confirm",
                iconHtml: "",
            }).then(async (result) => {
                if (result.isConfirmed) {
                    let answer = new ArtworkAnswer(item);
                    answer.delete().then((response) => {
                        this.readDataFromAPI();

                        Vue.swal({
                        title: " ",
                        text: "Deleted",
                        icon: "success",
                        toast: true,
                        position: "top-end",
                        timer: 2000,
                        showConfirmButton: false,
                        });
                    });
                }
            });
        }
    },
};
</script>
